import EmitterPrefetchCache from "../../internal/prefetching/EmitterPrefetchCache";
export default EmitterPrefetchCache;

//# sourceMappingURL=EmitterPrefetchCache.js.map